import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static targets = [
        'siteInternetLink',
        'linkedinLink',
        'instagramLink',
        'facebookLink',
        'twitterLink',
        'tikTokLink',
    ];

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    save() {
        // DDT-4363: the server normalises each link and refuses it with the reason;
        // the rules live in SocialProfileUrlNormalizer only.
        this.inputTargets().forEach((input) => {
            input.classList.remove('is-invalid');
            input.removeAttribute('aria-invalid');
        });

        const data = {
            'website': this.siteInternetLinkTarget.value,
            'linkedIn': this.linkedinLinkTarget.value,
            'instagram': this.instagramLinkTarget.value,
            'facebook': this.facebookLinkTarget.value,
            'twitter': this.twitterLinkTarget.value,
            'tiktok': this.tikTokLinkTarget.value,
        };

        showPreloader();

        $.ajax({
            url: routes['app_profile_editsocialnetworks'],
            type: 'POST',
            data: data,
            dataType: 'json',
            success: (response) => {
                if (response.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'social networks | Success',
                            'label': GA_EVENT_LABEL,
                        },
                    });
                    addAlert('success', response.message);
                    window.location.reload();
                }
            },
            error: (error) => {
                hidePreloader();
                const json = error.responseJSON;

                if (json && json.message) {
                    this.markInvalid(json.field);
                    // Long enough to read the example link in the message.
                    addAlert('danger', json.message, null, 8000);
                    return;
                }

                addAlert('danger', translations['profile.An unknown error occurred.']);
            },
        });
    }

    markInvalid(field) {
        const input = {
            'website': this.siteInternetLinkTarget,
            'linkedIn': this.linkedinLinkTarget,
            'instagram': this.instagramLinkTarget,
            'facebook': this.facebookLinkTarget,
            'twitter': this.twitterLinkTarget,
            'tiktok': this.tikTokLinkTarget,
        }[field];

        if (input) {
            input.classList.add('is-invalid');
            input.setAttribute('aria-invalid', 'true');
            input.focus();
        }
    }

    inputTargets() {
        return [
            this.siteInternetLinkTarget,
            this.linkedinLinkTarget,
            this.instagramLinkTarget,
            this.facebookLinkTarget,
            this.twitterLinkTarget,
            this.tikTokLinkTarget,
        ];
    }
}
